import { createPortal } from "react-dom";

import { notificationsStore } from "~/stores/notifications";
import NotificationItem from "../NotificationItem";

import "./style.less";

export default function Notifications() {
	const notifications = notificationsStore(storeState => storeState.notifications);

	return createPortal(<div className="notifications" data-len={notifications.active.length}>
		<div className="notifications__list">
			{ notifications.active.map(item => <NotificationItem key={item.id} data={item} />)}
		</div>
	</div>,
	document.querySelector('#portal') || document.body);
}
